import React from 'react'
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import AuthorizationImages from './AuthorizationImages.jsx'

const AuthorizePages = ({
  classes,
  groupDetails,
  patient,
  fullName,
  supplRows1,
  prodList,
  prodListColumns,
  supplRows2,
  images,
  onRemoveImage,
}) => {
  return (
    <>
      <div style={{ width: '20%' }}>
        <center>
          <Typography variant="h3" noWrap>
            <b>{groupDetails.hdetail1} - {groupDetails.hdetail2}</b>
          </Typography>
          <Typography variant="h6" noWrap>
            {groupDetails.hdetail11} / {groupDetails.hdetail12}
          </Typography>
          <hr />
          <Box className={classes.letterHead}>
            <p>{groupDetails.hdetail5}</p>
            <p>{groupDetails.hdetail7}</p>
          </Box>
        </center>
      </div>

      <div style={{ marginLeft: '200px', fontSize: '11pt', padding: '6px 0px 6px 16px' }}>
        <h1>Authorization Request for wound care</h1>
        <h3>to: {patient.medicalAid}</h3>
        <h3>Att: Pre-Authorization</h3>
        <h2>
          Please note that wound care was required for the following
          patient:
        </h2>
        <h3>Name: {fullName}</h3>
        <h3>Contact Number: {patient.mobile}</h3>
        <h3>Member Number: {patient.memberNo}</h3>
        <h3>ID: {patient.SAID}</h3>
        <h3>
          Referring Doc:{' '}{patient.referringDoctor}{'  '}
          {patient.referringDrNo}
        </h3>
      </div>

      <div>
        <Table className={classes.table} size="small">
          <TableHead />
          <TableBody>
            {supplRows1.map((row, index) => (
              <TableRow key={`${row.key}-${index}`} data-email-section="supplRows1">
                <TableCell
                  data-email-role="key"
                  style={{ width: '130pt' }}
                  component="th"
                  scope="row"
                >
                  {row.key}
                </TableCell>
                <TableCell data-email-role="value" contentEditable={true} suppressContentEditableWarning={true}>
                  {row.value}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      <div>
        <Table className={classes.table} size="small" style={{ width: 1000, tableLayout: 'fixed' }}>
          <TableHead>
            <TableRow>
              {prodListColumns.map((column) => (
                <TableCell
                  key={column.field}
                  style={{
                    width: column.width ? `${column.width}px` : undefined,
                    fontWeight: 700,
                  }}
                >
                  {column.headerName}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {prodList.map((row) => (
              <TableRow key={row.id}>
                {prodListColumns.map((column) => (
                  <TableCell key={`${row.id}-${column.field}`}>
                    {row[column.field] ?? ''}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      {Array.isArray(supplRows2) && supplRows2.length > 0 && (
        <div>
          <Table className={classes.table} size="small">
            <TableHead />
            <TableBody>
              {supplRows2.map((row, index) => (
                <TableRow key={`${row.key}-${index}`} data-email-section="supplRows2">
                  <TableCell
                    data-email-role="key"
                    style={{ width: '130pt' }}
                    component="th"
                    scope="row"
                  >
                    {row.key}
                  </TableCell>
                  <TableCell data-email-role="value" contentEditable={true} suppressContentEditableWarning={true}>
                    {row.value}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}

      <AuthorizationImages
        classes={classes}
        images={images}
        onRemoveImage={onRemoveImage}
      />
    </>
  )
}

export default AuthorizePages
